import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  Paper,
} from "@mui/material";

interface ContractModalProps {
  open: boolean;
  onClose: () => void;
  contractAccepted: boolean;
  onContractAcceptedChange: (accepted: boolean) => void;
}

export function ContractModal({
  open,
  onClose,
  contractAccepted,
  onContractAcceptedChange,
}: ContractModalProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper">
      <DialogTitle sx={{ fontWeight: 600, color: "#133859", textAlign: "center" }}>
        Contrato de Prestação de Serviços de Oftalmologia
      </DialogTitle>

      <DialogContent dividers>
        <Paper elevation={0} sx={{ p: { xs: 1, md: 2 } }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            SAGRADA VISÃO - PLATAFORMA OFTALNOW
          </Typography>

          <Box mt={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              1. DAS PARTES
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>1.1. PRESTADORA:</strong> SAGRADA VISÃO INSTITUTO DE OFTALMOLOGIA, Organização Social de Direito Privado, inscrita no CNPJ sob o nº 60.401.792/0001-38, com sede na Rua Dos Lírios, 525, Sala 8, Jardim Cuiabá, Cuiabá/MT, CEP 78043-122. Neste ato representada por seu Presidente, RODRIGO SANCHES DE OLIVEIRA, médico, inscrito no CPF sob o nº 802.047.321-15 e RG nº 1049856-7 SSP/MT.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>1.2. USUÁRIO/PACIENTE:</strong> Pessoa física devidamente identificada através do cadastro na plataforma eletrônica OFTALNOW, que aceita os termos deste contrato ao prosseguir com o agendamento.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              2. DO OBJETO
            </Typography>

            <Typography variant="body2" paragraph>
              O presente contrato tem por objeto a prestação de serviços médicos presenciais na área de oftalmologia (refração), intermediados pela plataforma eletrônica OFTALNOW, que conecta o paciente a médicos oftalmologistas credenciados.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>Parágrafo Único:</strong> Os serviços ora contratados NÃO constituem telemedicina. Trata-se de atendimento médico presencial em consultórios definidos pelos profissionais credenciados POR MEIO RANDÔMICO ATRAVÉS DAS VACÂNCIAS CADASTRADAS NA PLATAFORMA.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              3. DO SISTEMA DE TRIAGEM E VALORES (NÍVEIS I E II)
            </Typography>

            <Typography variant="body2" paragraph>
              O valor da consulta será definido de acordo com o perfil socioeconômico do paciente, validado via sistema:
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>PACIENTE NÍVEL I</strong> – VALOR R$ 180,00, destinado a pacientes beneficiário de algum benefício social, ou caracterizado como vulnerável através de convênio devidamente constituído.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>3.1. NÍVEL II:</strong> R$ 320,00 – Destinado a pacientes que NÃO forem localizados nos filtros de benefícios sociais ou vulnerabilidade mencionados acima.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              4. DO AGENDAMENTO E PAGAMENTO
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>4.1. Fluxo:</strong> Após o cadastro e filtragem de nível, o sistema gerará o pagamento via Pix, Cartão de Crédito ou Boleto, processado através da conta corrente da Prestadora na cooperativa SICREDI Ouro Verde.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>4.2. Designação do Médico:</strong> Confirmado o pagamento, o sistema apresentará, de forma randômica, o profissional, o horário e o local do atendimento, em um prazo máximo de 36 horas.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>4.3. Escopo do Valor:</strong> O valor pago refere-se estritamente à consulta de refração. Exames complementares e procedimentos não estão inclusos e devem ser negociados diretamente com o médico, seguindo a tabela da plataforma.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              5. REAGENDAMENTO E CANCELAMENTO
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>5.1. Direito de Arrependimento:</strong> Caso o paciente desista do atendimento, o Instituto Sagrada Visão realizará o reembolso integral no prazo de 10 (dez) dias.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>5.2. Alterações por Força Maior:</strong> O agendamento poderá ser alterado por ambas as partes, sem prejuízo, desde que a nova data não ultrapasse o 10º dia após o pagamento.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>5.3. Novo Agendamento:</strong> Em caso de alteração, o novo atendimento será REDEFINIDO pelo sistema randômico entre os profissionais disponíveis.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              6. DAS RESPONSABILIDADES
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>6.1. Da Plataforma OFTALNOW:</strong> Atua como meio eletrônico de acesso. Não possui responsabilidade técnica sobre o ato médico.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>6.2. Do Instituto Sagrada Visão:</strong> Responsável pelo credenciamento rigoroso de médicos registrados no CRM MT, com a devida qualificação (RQE) e ilibada reputação.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>6.3. Do Médico:</strong> A responsabilidade técnica pelo diagnóstico e tratamento é exclusiva do médico assistente devidamente identificado no ato do atendimento.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>6.4. Auditoria:</strong> Qualquer intercorrência ou conduta inadequada deve ser comunicada à auditoria da empresa para as providências administrativas cabíveis.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              7. PROTEÇÃO DE DADOS
            </Typography>

            <Typography variant="body2" paragraph>
              O paciente autoriza o cruzamento de seus dados com o CADÚNICO OU outra base de dados conveniados com a plataforma OFTALNOW bem como outros bancos de dados governamentais parceiros para fins estritos de classificação de valor da consulta, em conformidade com as normas de proteção de dados vigentes.
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              8. DO FORO
            </Typography>

            <Typography variant="body2" paragraph>
              As partes elegem o foro da Comarca de Cuiabá/MT para dirimir quaisquer dúvidas ou controvérsias oriundas deste contrato.
            </Typography>

            <Box sx={{ mt: 3, p: 2, bgcolor: "error.lighter", borderRadius: 1 }}>
              <Typography variant="body2" fontWeight={600} color="error.main">
                AO CLICAR EM "LI E ACEITO", O PACIENTE DECLARA ESTAR CIENTE DE TODAS AS CONDIÇÕES ACIMA E AUTORIZA A REALIZAÇÃO DO FILTRO SOCIOECONÔMICO.
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={contractAccepted}
                    onChange={(e) => onContractAcceptedChange(e.target.checked)}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body2" fontWeight={600}>
                    Li e aceito os termos do contrato e a política de tratamento de dados
                  </Typography>
                }
              />
            </Box>
          </Box>
        </Paper>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Fechar
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          disabled={!contractAccepted}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
